import Payout from '@/components/payout';

export default Payout;
